import React, { useState, useEffect } from "react";
import GoBack from "../../sub-components/GoBack";
import { FormGrid } from "../../Users/AddANewUser";
import Input from "../../../Input";
import Select from "../../../Select";
import TextArea from "../../../TextArea";
import toast from "react-hot-toast";
import { StockService } from "../../../../services/StockService";
import { useNavigate } from "react-router";
import {
  YieldUpload
} from "../../sub-components/DocumentUploads";
import {StampageService} from "../../../../services/StampageService";
import CsvFormatHint, { STUMPAGE_COLUMNS } from "../sub-components/CsvFormatHint";

// Conveyance and LIF uploads use the same form and file layout as stumpage; `type` tells
// the backend which one is being created.
export const STUMPAGE_TYPES = {
  stumpage: { type: "Stumpage", label: "Stumpage", path: "stampage", template: "stumpage-template.csv" },
  conveyance: { type: "Conveyance", label: "Conveyance", path: "conveyance", template: "conveyance-template.csv" },
  lif: { type: "LIF", label: "LIF", path: "lif", template: "lif-template.csv" },
};

const isCsv = (file) => file instanceof File && /\.csv$/i.test(file.name);

export const StumpageTypeForm = ({ kind = "stumpage" }) => {
  const config = STUMPAGE_TYPES[kind];
  const navigate=useNavigate();
  const [state, setState] = useState({
    rangeId: 0,
    concessionId: 0,
    speciesId:0,
    compartmentId: 0,
    description: "",
      contractorName:"",
      forestCode:"",
      cokNumber:"",
      referenceNumber:"",
      district:"",
      localMark:"",
      stoolLandOwners:"",
      districtAssembly:"",

    yield: ""
  });

  const [concessions, setConcessions] = useState([]);
  const [compartments, setCompartments] = useState([]);
  const [, setSpecies] = useState([]);
  const loadConcessionList = () => {
    StockService.GetAllConcessions().then((res) => {
      let data = res.map((country)=>{
        country.value = country.concessionId;
        country.label = country.concessionName;
        return country;
     })
      // data.unshift({value:0,label:"Make Selection"});
      
         setConcessions(data);
        //  console.log(concessions);
       
    });
  };
  useEffect(() => {
    loadConcessionList();
  }, []);


  const loadSpeciesList = () => {
      StampageService.GetRanges().then((res) => {
      let data = res.map((country)=>{
        country.value = country.yieldVolumeRangeId;
        country.label = country.rangeName;
        return country;
     })
         setSpecies(data);
        //  console.log(concessions);
       
    });
  };
  useEffect(() => {
    loadSpeciesList();
  }, []);


  const handleChange = (e) => {
    const { value, id } = e.target;
    setState((oldState) => ({ ...oldState, [id]: value }));
    if(id === 'concessionId'){
      let compactmentList = concessions.find(c=>c.concessionId === parseInt(e.target.value)); 
   
      if(compactmentList.compartments.length>0){
        let data = compactmentList.compartments.map((country)=>{
              country.value = country.compartmentId;
              country.label = country.compartmentName;
              return country;
          })
          console.log(data)
       setCompartments(data)
      }
     
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!(state.yield instanceof File)) {
      toast.error(`Attach the ${config.label} CSV file.`);
      return;
    }
    if (!isCsv(state.yield)) {
      toast.error(`The ${config.label} document must be a .csv file (${state.yield.name} isn't). Save it from Excel as CSV and try again.`, { duration: 8000 });
      return;
    }
    const toastId = toast.loading(`Saving ${config.label} ...`);
      StampageService.UploadStampage(
      state.yield,
      state.compartmentId,
      state.concessionId,
        state.description,
        state.contractorName,
          state.forestCode,
          state.cokNumber,
          state.referenceNumber,
          state.district,
          state.localMark,
          state.stoolLandOwners,
          state.districtAssembly,
          config.type
    )
      .then((res) => {
         toast.dismiss(toastId);
        if (res && res.isSuccessful) {
          toast.success(res.message);
          navigate(`/dashboard/stock-management/${config.path}`)

        } else {
          const nothingSaved = res && /failed to save data/i.test(res.message || "");
          toast.error(
            nothingSaved
              ? `Nothing was saved: no rows could be read from the file. Check it is a .csv with the column headers shown on the form.`
              : (res && res.message) || "An error occurred. Please try again later",
            { duration: 8000 }
          );
        }
      })
      .catch((err) => {
        // console.error(err);
      });
  };


  const [files] = useState([]);
  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    console.log(files);
  }, [files]);

  return (
    <form className="flex flex-col w-full" onSubmit={handleSubmit}>
      <GoBack />
      <h2 className="my-2 text-xl font-medium text-gray-700 ">New {config.label} Upload</h2>
      <FormGrid>

        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Concession</span>
          
          <Select
            placeholder="Concession"
            type="text"
            value={state.concessionId}
            options={concessions}
            onChange={handleChange}
            required
            id="concessionId"
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Compartment</span>
          <Select
            placeholder="Compartment"
            type="text"
            label="Select A Compartment"
            value={state.compartmentId}
            options={compartments}
            onChange={handleChange}
            required
            id="compartmentId"
          />
        </label>
        {/*<label className="block">*/}
        {/*  <span className="block mb-3 text-gray-700 text-md">Range</span>*/}
        {/*  <Select*/}
        {/*    placeholder="Species"*/}
        {/*    type="text"*/}
        {/*    label="Select A Range"*/}
        {/*    value={state.rangeId}*/}
        {/*    options={species}*/}
        {/*    onChange={handleChange}*/}
        {/*    required*/}
        {/*    id="rangeId"*/}
        {/*  />*/}
        {/*</label>*/}

        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Description</span>
          <TextArea
            placeholder="Description"
            type="text"
            value={state.description}
            onChange={handleChange}
            required
            id="description"
          />
        </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
           Contractor Name
          </span>
              <Input
                  id="contractorName"
                  placeholder="Contractor Name"
                  type="text"
                  value={state.contractorName}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Forest Code
          </span>
              <Input
                  id="forestCode"
                  placeholder="Forest Code"
                  type="text"
                  value={state.forestCode}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Cok Number
          </span>
              <Input
                  id="cokNumber"
                  placeholder="cok Number"
                  type="text"
                  value={state.cokNumber}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Reference Number
          </span>
              <Input
                  id="referenceNumber"
                  placeholder="Reference Number"
                  type="text"
                  value={state.referenceNumber}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            District
          </span>
              <Input
                  id="district"
                  placeholder="District"
                  type="text"
                  value={state.district}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Local Mark
          </span>
              <Input
                  id="localMark"
                  placeholder="Local Mark"
                  type="text"
                  value={state.localMark}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            Stool Land Owners
          </span>
              <Input
                  id="stoolLandOwners"
                  placeholder="Stool Land Owners"
                  type="text"
                  value={state.stoolLandOwners}
                  onChange={handleChange}
                  required
              />
          </label>
          <label className="block">
          <span className="block mb-3 text-gray-700 text-md">
            District Assembly
          </span>
              <Input
                  id="districtAssembly"
                  placeholder="District Assembly"
                  type="text"
                  value={state.districtAssembly}
                  onChange={handleChange}
                  required
              />
          </label>

      </FormGrid>
      <h3 className="my-2 text-lg font-medium text-gray-700 ">{config.label} Document</h3>
      <CsvFormatHint columns={STUMPAGE_COLUMNS} templateName={config.template} />
      {/*<TreeDropzone files={files} setFiles={setFiles}/>*/}
      <YieldUpload preview={state.yield}  docname="yield" state={state}/>
      <button
        type="submit"
        className="w-full sm:w-auto sm:px-3 bg-[#3e7c17] hover:bg-[#356C14] text-white font-semibold py-2 lg:py-3 my-3 rounded rounded-md self-end"
      >
        Create {config.label}
      </button>
    </form>
  );
};

const AddStampage = () => <StumpageTypeForm kind="stumpage" />;

export default AddStampage;
